export interface WebEnvDetails {
  sourceVersion: string | undefined;
  disableAnimations: boolean;
  isUserFacingDeployment: boolean;
  chargebeeSite: string;
  turnstileSiteKey: string;
}

export const getWebEnvDetails = (): WebEnvDetails => {
  const locationUrl = new URL(window.location.href);

  // We can simulate user facing by navigating to `/app?_forceUserFacing=true`.
  // It will remain until the page is reloaded.
  const isUserFacingDeployment =
    locationUrl.hostname.startsWith("www.") ||
    locationUrl.hostname.startsWith("beta.") ||
    locationUrl.searchParams.get("_forceUserFacing") === "true";

  return {
    isUserFacingDeployment,
    disableAnimations: import.meta.env.DISABLE_ANIMATIONS_WEBAPP,
    sourceVersion: import.meta.env.SOURCE_VERSION,
    chargebeeSite: isUserFacingDeployment ? "appraised" : "appraised-test",
    // Forces an interactive challenge
    // turnstileSiteKey: "3x00000000000000000000FF",
    // cf. https://developers.cloudflare.com/turnstile/frequently-asked-questions/#are-there-sitekeys-and-secret-keys-that-can-be-used-for-testing
    turnstileSiteKey:
      isUserFacingDeployment ? "0x4AAAAAAABnZe6V_ovwUhwJ"
      : "Cypress" in window ?
        // always passes for automated testing
        "1x00000000000000000000AA"
        // dev configuration
      : "0x4AAAAAAABn33SsVrMP87V9",
  };
};
